<template>
  <b-modal
    v-model="data.showModal"
    size="md"
    button-size="sm"
    modal-class="template-modal"
    title-class="w-full"
    footer-class="w-full"
    no-fade
    @show="onShow"
    @hide="onHide"
    scrollable
  >
    <!-- Modal header -->
    <div slot="modal-title">
      <div class="flex w-full justify-between">
        Recipe for {{ data.candleIds.length | format }} candle(s)
      </div>
    </div>

    <!-- Modal content -->
    <div class="flex flex-col gap-2">
      <table class="table table-google">
        <tbody>
          <tr>
            <td>Number of Candles</td>
            <td>
              <div class="w-full flex justify-end">
                <b-form-input
                  v-model="data.candleCount"
                  type="number"
                  size="sm"
                  min="1"
                  autocomplete="off"
                  class="w-50"
                ></b-form-input>
              </div>
            </td>
          </tr>
          <tr v-if="data.candleIds.length === 1">
            <td>Recommended candles</td>
            <td>
              <div class="flex justify-end">
                <span v-if="isLoading">Loading..</span>
                <span v-else-if="recipe">
                  {{ recipe[0].details.min_candles | format }}
                </span>
                <span v-else>
                  No data available
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal footer -->
    <div slot="modal-footer" class="w-full d-flex gap-4 justify-content-between items-center">
      <div class="flex w-full justify-content-between">
        <div>
          <b-btn
            size="sm"
            variant="primary"
            @click="onPrint"
          >
            Next
          </b-btn>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'RecipeModal',
  components: {},
  props: {
    data: Object,
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0;
    },
    canSave() {
      return true;
    },
    preventMessage() {
      return 'You have unsaved changes. Are you sure you want to close?';
    },
    preventClose() {
      return false;
    },
  },
  data() {
    return {
      loadingCount: 0,
      filters: {},
      options: {},
      recipe: null,
    };
  },
  methods: {
    fetchRecipe() {
      if (this.data.candleIds.length !== 1) {
        return;
      }
      this.loadingCount++;
      this.$http
        .get('/candle_recipe/data')
        .query({ candleIds: this.data.candleIds })
        .query({ candleCount: 1 })
        .then((res) => {
          this.recipe = res.body;
        })
        .catch((err) => {
          this.$toast.error(`Failed to fetch candle: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchAll() {
      this.fetchRecipe();
    },
    onSave() {
      // Implement logic
    },
    onShow() {
      this.fetchAll();
    },
    onClose() {
      this.data.showModal = false;
      this.$emit('close');
    },
    onPrint() {
      const query = {
        candleIds: this.data.candleIds.join(','),
        candleCount: this.data.candleCount,
      };
      window.open(`/api/candle_recipe/html?${new URLSearchParams(query).toString()}`, '_blank').focus();
      this.onClose();
    },
    onHide(event) {
      if (this.preventClose && !confirm(this.preventMessage)) {
        event.preventDefault();
        return;
      }
      this.candle = null;
    },
  },
};
</script>

<style lang="scss">
</style>
